import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { RootState } from '../../types/common.types';

import { setNewNotifications } from '../../slices/system/system.slice';

import Header from '../../components/common/header/Header';

const HeaderContainer = () => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfile, setShowProfile] = useState(false);

  const navigate = useNavigate();

  const location = useLocation();

  const { newNotifications } = useSelector(({ system }: RootState) => system);

  const dispatch = useDispatch();

  const toggleNotifications = () => {
    setShowNotifications((prevState) => !prevState);
    setShowProfile(false);

    if (newNotifications && !showNotifications) {
      dispatch(setNewNotifications(false));
    }
  };

  const toggleProfile = () => {
    setShowProfile((prevState) => !prevState);
    setShowNotifications(false);
  };

  const navigateToSettings = () => {
    if (location.pathname === '/settings') navigate(-1);

    navigate('/settings');
  };

  return (
    <Header
      showNotifications={showNotifications}
      showProfile={showProfile}
      newNotifications={newNotifications}
      toggleNotifications={toggleNotifications}
      toggleProfile={toggleProfile}
      navigateToSettings={navigateToSettings}
    />
  );
};

export default HeaderContainer;
